// extracted by mini-css-extract-plugin
export var cartIcon = "_or-0";
export var cartIconContainer = "_or-1";